import { Editor } from "primereact/editor";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import REIToggablePanel from "../../../components/ui/toggablePanel";
import { REIButton } from "../../../components/ui";
import { httpPost } from "../../../services/httpService";
import { ApiEndPoints } from "../../../utils/endpoints";
import { MEMBER_KEY } from "../../../utils/constants";
import { IMyEntityAndGoals } from "../../../interface/myEntityAndGoals";

const NotesAndGoals: React.FC<{ entityData: IMyEntityAndGoals; isNote: boolean }> = ({ entityData, isNote }) => {
  const [isNoteOpen, setIsNoteOpen] = useState<boolean>(false);
  const memberId = localStorage.getItem(MEMBER_KEY);
  const [text, setText] = useState<string>("");
  const handleNoteToggle = (event: React.MouseEvent) => {
    setIsNoteOpen((prev) => !prev);
  };
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    if (entityData) {
      isNote ? setText(entityData.MyNotes) : setText(entityData.Goals);
    }
  }, [entityData.MyNotes]);

  const updateMemberEntity = () => {
    httpPost(`${ApiEndPoints.tracker}MemberEntity/Update/`, {
      CountryCode: entityData.CountryCode,
      EntityName: entityData.EntityName,
      EntityTypeCode: entityData.EntityTypeCode,
      GoalAfterTaxCashFlow: entityData.GoalsTotal.Target.PostTaxCashflow,
      GoalAnnualRent: entityData.GoalsTotal.Target.AnnualRent,
      GoalDesc: !isNote ? text : entityData.Goals,
      GoalEquityUnlocked: entityData.GoalsTotal.Target.Equity,
      GoalPortfolioValue: entityData.GoalsTotal.Target.PortfolioValue,
      GoalPreTaxCashFlow: entityData.GoalsTotal.Target.PreTaxCashflow,
      MemberEntityId: entityData?.EntityId,
      MemberId: memberId,
      MemberProfiles: entityData.MemberProfiles,
      Note: isNote ? text : entityData.MyNotes,
    })
      .then((data) => {
        if (data.status === 200) {
          setIsNoteOpen(false);
        } else {
          toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: data.error,
            life: 3000,
          });
        }
      })
      .catch((error) => {
        console.error("Error updating note:", error);
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: error.message,
          life: 3000,
        });
      })
      .finally(() => {
        setIsNoteOpen(false);
      });
  };

  return (
    <REIToggablePanel
      header={`${isNote ? "MY NOTES" : "DESCRIBE YOUR GOALS"}`}
      istoggleable={false}
      contentComponent={
        <>
          {!isNoteOpen && text == "" && (
            <REIButton
              id={`megng-btn-add-${isNote ? "note" : "goal"}`}
              label={isNote ? "Add note" : "Add goal"}
              icon="pi pi-plus"
              onClick={function (event: React.MouseEvent<HTMLButtonElement>): void {
                setIsNoteOpen((prev) => true);
              }}
            ></REIButton>
          )}
          {text && !isNoteOpen && (
            <div
              id={`megng-lnk-content-${isNote ? "note" : "goal"}`}
              data-testid={`megng-lnk-content-${isNote ? "note" : "goal"}`}
              className="w-full content-center"
              onClick={handleNoteToggle}
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          )}

          {isNoteOpen && (
            <>
              <Editor
                value={text}
                onTextChange={(e) => setText(e.htmlValue || "")}
                style={{ height: "120px" }}
              ></Editor>
              <div className="mt-2 flex flex-row justify-end gap-2">
                <REIButton
                  id={`megng-btn-save-${isNote ? "note" : "goal"}`}
                  label="Save"
                  disabled={isNote ? entityData.MyNotes === text : entityData.Goals === text}
                  onClick={() => {
                    updateMemberEntity();
                  }}
                  icon="pi pi-check"
                  classNames="mr-2"
                ></REIButton>
                <REIButton
                  id={`megng-btn-cancel-${isNote ? "note" : "goal"}`}
                  onClick={function (event: React.MouseEvent<HTMLButtonElement>): void {
                    setIsNoteOpen((prev) => false);
                  }}
                  label="Cancel"
                  icon="pi pi-times "
                  classNames=""
                ></REIButton>
              </div>
            </>
          )}
        </>
      }
      defaultCollapse={false}
    ></REIToggablePanel>
  );
};

export default NotesAndGoals;
